<template>
    <div v-wechat-title="title" style="height: 100%">
        <!-- <CloseButton type="close" msg="closeWindow" :title="title"></CloseButton> -->
        <el-table ref="cus-table" :data="vitalSignDatas" @row-click="rowClick" :indent="10" tooltip-effect="light" border :row-key="setRowKeys" :height="tableHeight">
            <el-table-column type="index" label="序号" fixed="left" align="center" width="40" header-align="center"> </el-table-column>
            <el-table-column prop="name" width="110" fixed="left" label="项目" header-align="center"> </el-table-column>
            <el-table-column :prop="item.prop" v-for="(item, index) in columns" :key="`${item.prop}${index}`" size="mini" header-align="center" align="center">
                <span slot="header">
                    <span>{{ item.label }}</span>
                    <span>
                        <span class="btn el-icon-delete fg-danger cus-button is-circle" v-show="!is_archived" @click.stop="deleteVitalSign({ prop: item.prop })"></span>
                    </span>
                </span>
                <div
                    @click="active_item = [scope.$index, index]"
                    slot-scope="scope"
                    :key="item.prop"
                    :class="{ 'bg-write': !filter_readonly2(item, scope.row), ellipsis: filter_readonly(item, scope.row) }"
                    style="min-height: 20px; width: 100%"
                >
                    <TextFormatter class="float" v-if="filter_readonly(item, scope.row)" type="float" v-model="scope.row[item.prop]"></TextFormatter>
                    <item-input
                        :autofocus="active_item[0] == scope.$index && active_item[1] == index"
                        v-else
                        type="float"
                        v-model="scope.row[item.prop]"
                        @activeRow="setActiveRow(arguments)"
                        @blur="blur({ index: scope.$index, row: scope.row, prop: item.prop, column: item })"
                        @input="change({ row: scope.row, prop: item.prop })"
                    ></item-input>
                </div>
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `VitalSign`,
    props: {},
    data() {
        return {
            title: `监护数据`,
            token: this.$route.query.token,
            columns: [],
            vitalSignDatas: [],
            expandRow: [],
            isChanged: false,
            active_row: undefined,
            active_item: [],
            isCtrl: false,
            selected: [],
            choosen: undefined,
            tableBody: null,
            order: ``,
            is_archived: null
        }
    },
    created() {
        sessionStorage.setItem(`token`, this.token)
        this.loadColumnList()
    },
    computed: {
        ...mapGetters([`screenHeight`]),
        tableHeight() {
            return (this.screenHeight && this.screenHeight - 50) || 0
        },
        columnList() {
            return [
                {
                    type: `string`,
                    label: `序号`,
                    prop: `id`,
                    isKey: true,
                    fixed: `left`
                },
                {
                    type: `string`,
                    label: `项目`,
                    prop: `name`,
                    isListable: true,
                    width: `110px`,
                    fixed: `left`
                }
            ].concat(this.columns)
        },
        keyColumns() {
            return _.filter(this.columns, { isKey: true })
        }
    },
    methods: {
        catKeyVal(item) {
            return `${item.id}`
        },
        setRowKeys(row) {
            return this.catKeyVal(row)
        },
        filter_readonly(column, row) {
            if (column.readonly == true) {
                return true
            }

            if (row.active) {
                if (column.activereadonly == true) {
                    return true
                }
                if (column.activereadonly && _.isFunction(column.activereadonly)) {
                    return column.activereadonly(this, { row: row, column, area: `list` })
                }
                return false
            }
            if (column.isDisplayOrder || column.type == `buttongroup`) return false // todo：暂时特殊处理
            if (this.active_row == this.catKeyVal(row) || column.type == `checkbox`) {
                if (column.readonly && _.isFunction(column.readonly)) {
                    return column.readonly(this, { row: row, column, area: `list` })
                }
                // if(column.type=='remoteselect'||column.type=='remotemultiselect'){ //todo：暂时特殊处理
                //   return  column.readonly||false
                // }
                return column.readonly == undefined || column.readonly == true
            }
            return true
        },
        filter_readonly2(column, row) {
            if (column.readonly == true) {
                return true
            }
            if (row.active) {
                return false
            }
            if (column.isDisplayOrder || column.type == `buttongroup` || this.active_row == this.catKeyVal(row)) return true // todo：暂时特殊处理
            if (column.readonly && _.isFunction(column.readonly)) {
                return column.readonly(this, { row: row, column, area: `list` })
            }
            if (column.type == `checkbox`) {
                return true
            }
            return column.readonly == undefined || column.readonly == true
        },
        rowClick(row, event, column) {
            if (this.isCtrl) {
                this.$refs[`cus-table`].toggleRowSelection(row)
            }
            let k = this.catKeyVal(row)
            this.active_row = k
            let r = []
            r.push(k)
            this.$emit(`extrabutton-click`, { emit: `rowClick`, row, event, column })
            this.expandRow = r
        },
        blur({ index, row, prop, cell }) { // 监听更改的行
            let th = this
            if (th.isChanged) {
                let r = { ...row.cell_class }
                if (row[prop] < row.lower_warn || row[prop] > row.upper_warn) {
                    r[prop] = `over_limit`
                } else {
                    r[prop] = ``
                }
                th.$set(row, `cell_class`, r)
                th.saveVitalSignData(prop, row)
            }
        },
        deleteVitalSign({ prop }) {
            let data = {
                biz_surgery_info_id: this.$route.query.surgery_id,
                data_dt: this.$moment(prop).format(`YYYY/MM/DD HH:mm:ss`),
                enum_record_type: this.$route.query.record_type
            }

            return new Promise(resolve => {
                let req = this.myaxios.post(`/api/Operation/Monitor/DeleteVitalSign`, data)
                req.then(data1 => {
                    data1.map(d => {
                        let message = {
                            id: d.id,
                            data_dt: this.$moment(d.data_dt).format(`YYYY/MM/DD HH:mm:ss`),
                            key: d.dic_physio_param_id,
                            value: ``
                        }
                        console.log(`send to mzd message`)
                        console.log(message)
                        this.sendMessage(message)
                    })
                    this.loadColumnList()
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        setActiveRow(args) {
            let _this = this
            let rowIndex = args[0]
            let cellIndex = args[1]
            let row = _this.vitalSignDatas[rowIndex]
            if (this.isCtrl) {
                this.$refs[`cus-table`].toggleRowSelection(row)
            } else {
                this.$refs[`cus-table`].setCurrentRow(row)
            }
            let k = this.catKeyVal(row)
            this.active_row = k
            let r = []
            r.push(k)
            this.expandRow = r
            let direction = args[2]
            _this.active_item = [rowIndex, cellIndex - 2]
            _this.$nextTick(() => {
                let activeRow = _this.$refs[`cus-table`].$el.querySelector(`.el-table__body-wrapper`).querySelectorAll(`.el-table__row`)[rowIndex]
                if (activeRow && activeRow.children[cellIndex]) {
                    let activeInput = activeRow.children[cellIndex].getElementsByTagName(`input`)[0]
                    let celllenth = activeRow.cells.length
                    let rowlen = activeRow.children.length // 行数
                    while (!activeInput) {
                        switch (direction) {
                        case `up`:
                            rowIndex = rowIndex - 1
                            if (rowIndex < 0) { rowIndex = rowlen - 1 }
                            break
                        case `down`:
                            rowIndex = rowIndex + 1
                            if (rowIndex === rowlen) { rowIndex = 0 }
                            break
                        case `left`:
                            cellIndex = cellIndex - 1
                            if (cellIndex < 0) { cellIndex = celllenth - 1 }
                            break
                        case `right`:
                            cellIndex = cellIndex + 1
                            if (cellIndex === celllenth) { cellIndex = 0 }
                            break
                        case `enter`:
                            cellIndex = cellIndex + 1
                            if (cellIndex === celllenth) {
                                cellIndex = 0
                                rowIndex += 1
                                if (rowIndex === rowlen) { rowIndex = 0 }
                                activeRow = this.$refs[`cus-table`].$el.querySelector(`.el-table__body-wrapper`).querySelectorAll(`.el-table__row`)[rowIndex]
                            }
                            break
                        }
                        activeInput = activeRow && activeRow.children[cellIndex] && activeRow.children[cellIndex].getElementsByTagName(`input`)[0]
                    }
                    activeInput && activeInput.focus()
                    activeInput && activeInput.select()
                }
            })
        },
        change({ row, prop }) {
            let th = this
            th.isChanged = true
        },
        loadColumnList() {
            let data = {
                surgeryId: this.$route.query.surgery_id,
                step: this.$route.query.step,
                begin: this.$route.query.begin_time,
                end: this.$route.query.end_time,
                recordType: this.$route.query.record_type
            }
            let th = this
            return new Promise(resolve => {
                let r = []
                let req = this.myaxios.get(`/api/Operation/Monitor/GetMonitorBySurgery`, data)
                let req1 = this.myaxios.get(`/api/AcisSystem/RecordConfig/SurgeryInfoMapRecord?surgeryInfoId=${data.surgeryId}&recordType=${data.recordType}`)

                this.myaxios.all(req, req1).then(([data, data1]) => {
                    this.is_archived = data1.is_archived
                    _.forIn(data[0].datas, function(value, key) {
                        let r1 = {
                            type: `float`,
                            prop: key,
                            label: th.$moment(key).format(`HH:mm`),
                            isListable: true,
                            size: `mini`,
                            readonly: !!data1.is_archived, // 归档后监护数据只能查看
                            blur: (that, { index, row, prop, column }) => {
                                if (th.isChanged) {
                                    let r = { ...row.cell_class }
                                    if (row[prop] < row.lower_warn || row[prop] > row.upper_warn) {
                                        r[prop] = `over_limit`
                                    } else {
                                        r[prop] = ``
                                    }
                                    th.$set(row, `cell_class`, r)
                                    th.saveVitalSignData(prop, row)
                                }
                            },
                            change: (that, { row, prop }) => {
                                th.isChanged = true
                            }
                        }
                        r.push(r1)
                    })
                    th.columns = r
                    th.vitalSignDatas = _.map(data, d => {
                        let warningClass = {}
                        _.forEach(d.datas, (value, key) => {
                            if (value && (d.lower_warn > value || d.upper_warn < value)) {
                                warningClass[key] = `over_limit`
                            }
                        })
                        let keys = d.datas
                        let items = {
                            id: d.id,
                            name: d.name
                        }
                        let newObj = { cell_class: warningClass, upper_warn: d.upper_warn, lower_warn: d.lower_warn }
                        _.assign(newObj, keys, items)
                        return newObj
                    })
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        saveVitalSignData(prop, row) {
            let rowvalue = eval(`row["${prop}"]`)
            if (rowvalue != `` && isNaN(rowvalue)) {
                this.$message.error(`“${rowvalue}”数据格式有误！请重新录入`)
                return
            }
            let data = {
                dic_physio_param_id: row.id,
                biz_surgery_info_id: this.$route.query.surgery_id,
                data_dt: this.$moment(prop).format(`YYYY/MM/DD HH:mm:ss`),
                value: rowvalue,
                enum_record_type: this.$route.query.record_type
            }
            return new Promise(resolve => {
                let req = this.myaxios.put(`/api/Operation/Monitor/Put?step=${this.$route.query.step}`, data)
                req.then(data => {
                    let message = {
                        id: data.id,
                        data_dt: this.$moment(data.data_dt).format(`YYYY/MM/DD HH:mm:ss`),
                        key: data.dic_physio_param_id,
                        value: data.value
                    }
                    this.isChanged = false
                    this.sendMessage(message)
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        sendMessage(message) {
            let r = typeof winformMsg
            if (r != `undefined`) {
                var cefJson = {
                    data: message,
                    action: `refresh`
                }
                winformMsg.acceptMessage(cefJson)
            }
        }
    },
    watch: {
        "vitalSignDatas": {
            handler() {
                this.$nextTick(() => {
                    this.$refs[`cus-table`].doLayout()
                })
            },
            deep: true
        }
    }
}
</script>
<style >
.over_limit span,
.over_limit input {
    color: red !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Anesthsia/VitalSign.vue